import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
} from "@angular/material/dialog";
import { NotificationService } from "../../../services/notification.service";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInput } from "@angular/material/input";
import { MatFormField, MatLabel, MatPrefix } from "@angular/material/form-field";
import { TranslatePipe, TranslateService } from "@tolgee/ngx";
import { ProtocolService } from "../../../services/protocol.service";

@Component({
	selector: "app-error-report",
	templateUrl: "./error-report.component.html",
	styleUrls: ["./error-report.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		MatDialogContent,
		MatFormField,
		MatLabel,
		MatInput,
		ReactiveFormsModule,
		FormsModule,
		MatIcon,
		MatPrefix,
		MatDialogActions,
		MatButton,
		MatDialogClose,
		MatProgressSpinner,
		TranslatePipe,
	],
})
export class ErrorReportComponent {
	data = inject(MAT_DIALOG_DATA);
	private protocolService = inject(ProtocolService);
	private dialogRef = inject<MatDialogRef<ErrorReportComponent>>(MatDialogRef);
	private toastr = inject(NotificationService);
	private translate = inject(TranslateService);

	isLoading: boolean = false;
	notes: string;

	apply() {
		this.isLoading = true;
		this.protocolService.postProtocolError(this.data.protocol.id, this.data.error, this.notes).subscribe({
			next: (response) => {
				this.isLoading = false;
				if (response.status == 204) {
					this.toastr.success(this.translate.instant("protocol.error.report.success"));
					this.dialogRef.close(true);
				} else {
					this.toastr.error(this.translate.instant("core.message.error.unknown"));
				}
			},
			error: () => {
				this.isLoading = false;
			},
		});
	}
}
